import { Component, OnInit } from '@angular/core';
import { User } from '../../../shared/classes/user';
import { TdDialogService, TdLoadingService } from '@covalent/core';
import { UserService } from '../user.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BranchService } from '../../accounting/branches/branch.service';
import { Branch } from '../../accounting/branch';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Component({
  selector: 'app-user-new',
  templateUrl: './user-new.component.html',
  styleUrls: ['./user-new.component.scss'],
  providers: [UserService]
})
export class UserNewComponent implements OnInit {
  currentUser: User;
  originalUser: User;

  password: string;

  userRoles: any = {};
  originalUserRoles: any = {};

  userBranches: Branch[] = [];
  originalUserBranches: Branch[] = [];

  title: string;
  isEditMode: boolean;

  roles: { id: string, name: string }[] = [];
  languages: any[] = [];
  branches: Branch[] = [];

  printers$: Observable<any[]>;

  constructor(private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _userService: UserService,
    private _branchService: BranchService,
    public _authService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.route.paramMap.switchMap((params: ParamMap) => this.mode(params.get('id'))).subscribe(
      (currentUser: User) => {
        this.currentUser = currentUser;

        if (!(this.currentUser.branch_list && Array.isArray(this.currentUser.branch_list))) {
          this.currentUser.branch_list = [];
        }

        console.log(this.currentUser);

        // TODO: Remove the below fix when moving to nodeJS
        this.currentUser.language = Number.parseInt(this.currentUser.language+'');

        // Load up the reference data
        this.originalUser = Object.assign({}, this.currentUser);

        this._loadingService.resolve('loading');
      });

    this.getRoles();
    this.getBranches();
    this.getLanguages();
    this.printers$ = this._userService.getPrinters();
  }

  mode(id: string): Observable<User> {
    if (id != 'new') {
      this.title = 'Edit User';
      this.isEditMode = true;
      return this._userService.getOneUser(id);
    }

    this.title = 'Create User';
    this.isEditMode = false;
    return Observable.of(new User());
  }

  updateRoles($event, role) {
    if ($event) {
      this.currentUser.module_roles.push(role)
    } else {
      this.currentUser.module_roles = this.currentUser.module_roles.filter(function (r) { return r.id != role.id })
    }

    console.log(this.currentUser)
  }

  hasRole(role) {
    return this.currentUser.module_roles.filter((r) => { return r.id == role.id }).length > 0;
  }


  updateBranches($event, branch) {
    if ($event) {
      this.currentUser.branch_list.push(branch)
    } else {
      this.currentUser.branch_list = this.currentUser.branch_list.filter(function (b) { return b.id != branch.id })
    }

    console.log(this.currentUser)
  }

  hasBranch(branch) {
    // No branches? Straight false
    if (!(this.currentUser && this.currentUser.branch_list && Array.isArray(this.currentUser.branch_list))) {
      return false;
    }
    return this.currentUser.branch_list.filter((b) => { return b.id == branch.id }).length > 0;
  }

  changed(): boolean {
    for (let prop in this.currentUser) {
      if (this.currentUser[prop] != this.originalUser[prop]) {
        return true;
      }
    }

    return false;
  }

  getRoles() {
    this._userService.getRoles().subscribe(
      response => {
        if (response && Array.isArray(response)) {
          this.roles = response;
        } else {
          this.roles = [];
        }
      }
    );
  }

  getBranches() {
    this._branchService.getBranches().subscribe(
      response => {
        if (response && Array.isArray(response)) {
          this.branches = response;
        } else {
          this.branches = [];
        }
      }
    );
  }

  getLanguages() {
    this._userService.getLanguages().subscribe(
      response => {
        this.languages = response;
      });
  }

  goBack() {
    this.router.navigate(['/admin', 'users', 'list']);
  }

  createUser() {
    this._userService.addOneUser(this.currentUser).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.currentUser.id = response['id'];

          // Assign the password. Don't care if it fails, it will just have the default password Pa$$w0rd
          if (this.password != null) this._userService.changePassword(this.currentUser.id, this.password).subscribe();

          // Reload up the reference data
          this.originalUser = Object.assign({}, this.currentUser);

          this.isEditMode = true;
          this._loadingService.resolve('loading');
          this._dialogService.openAlert({
            message: 'User ' + this.currentUser.name + ' created successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/admin', 'users', 'list']);
          });
        } else {
          this._loadingService.resolve('loading');

          this._dialogService.openAlert({
            message: 'Could not create user ' + this.currentUser.name + '. Try again later',
            title: 'Failed!',
          });
        }
      },
      error => {
        this._loadingService.resolve('loading');

        this._dialogService.openAlert({
          message: 'Error updating user ' + this.currentUser.name + ': ' + error,
          title: 'Error!',
        });
      },
      () => { }
    );
  }

  saveUser() {
    console.log(this.currentUser);
    this._userService.updateOneUser(this.currentUser).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {

          // Reload up the reference data
          this.originalUser = Object.assign({}, this.currentUser);

          this.isEditMode = true;
          this._loadingService.resolve('loading');
          this._dialogService.openAlert({
            message: 'User ' + this.currentUser.name + ' updated successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/admin', 'users', 'list']);
          });
        } else {
          this._loadingService.resolve('loading');

          this._dialogService.openAlert({
            message: 'Could not update user ' + this.currentUser.name + '. Try again later',
            title: 'Failed!',
          });
        }
      },
      error => {
        this._loadingService.resolve('loading');

        this._dialogService.openAlert({
          message: 'Error updating user ' + this.currentUser.name + ': ' + error,
          title: 'Error!',
        });
      },
      () => { }
    );
  }

  resetPassword() {
    console.log('Password Reset');
    this._dialogService.openPrompt({
      title: 'Enter new password',
      message: 'Please enter the new password for this user'
    }).afterClosed().subscribe(
      result => {
        if (result) {
          this._userService.changePassword(this.currentUser.id, result).subscribe(
            response => {
              if (response['status'] == 'SUCCESS') {
                this._dialogService.openAlert({
                  title: 'Success!',
                  message: 'Password changed successfully'
                }).afterClosed().subscribe(r => { this.goBack() });
              } else {
                this._dialogService.openAlert({
                  title: 'Failed!',
                  message: 'Password could not be changed'
                });
              }
            }
          );
        }

        // Copy to clipboard in case you want to send it via email, e.g.
        this.copyToClipboard(result);
      },
      error => {
        this._dialogService.openAlert({
          title: 'Failed!',
          message: 'Password could not be changed'
        });
      }
    );

  }

  copyToClipboard(text: string) {
    let selBox = document.createElement('textarea');

    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;

    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();

    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/admin/user-new/user-new.component.ts